// extracted by mini-css-extract-plugin
export default {"container":"profileMenu_container__sSRuv","main":"profileMenu_main__nnZB8","title":"profileMenu_title__8RWZe","grid":"profileMenu_grid__YnR5G"};